<template>
  <main-sidebar :name="name" :title="$tc('container',2)|capitalize">
    <div class="p-4">

      <vs-row vs-justify="center" class="mb-4">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <label>{{ $tc('label')|capitalize }}</label>
          <vs-input
            name="label"
            :placeholder="$t('label')"
            v-model.number="params.label"
            class="w-full"
            autocomplete="off"
            :disabled="true"
          />
        </vs-col>
      </vs-row>

        
      <vs-row vs-justify="center" class="mb-4">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6" class="px-1">
          <label>{{ $tc('quantity')|capitalize }}</label>
          <vs-input
            name="quantity"
            :placeholder="$t('quantity')"
            v-model.number="params.quantity"
            class="w-full"
            autocomplete="off"
            :disabled="true"
          />
        </vs-col>
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6" class="px-1">
          <label>{{ $tc('type')|capitalize }}</label>
          <v-select
            :options="containerTypes"
            label="name"
            :reduce="type => type.id"
            v-model="params.type"
            v-validate="'required'"
            name="type"
            class="w-full"
          />
        </vs-col>
        <v-select
            :hidden="true"
          />
      </vs-row>
       

       <vs-row vs-justify="center" class="mb-4">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <label>{{ $tc('location')|capitalize }}</label>
          <vs-input
            name="location_name"
            v-model.number="params.location_name"
            class="w-full"
            autocomplete="off"
            :disabled="true"
          />
        </vs-col>
      </vs-row>

       <vs-row vs-justify="center" class="mb-4">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <label>{{ $tc('comment')|capitalize }}</label>
          <vs-input
            name="comment"
            :placeholder="$t('comment')"
            v-model.number="params.comment"
            class="w-full"
            autocomplete="off"
            :disabled="true"
          />
        </vs-col>
      </vs-row>

      





      <vs-row vs-justify="center" class="mb-4">
        <vs-col
          type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="6"
          class="pr-2"
        >
          <vs-button
            type="filled"
            color="primary"
            @click="submitForm"
            class="w-full"
            :disabled="this.isEditing ? disabledUpdate : disabledStore"
            >{{ $t('submit') }}</vs-button
          >
        </vs-col>
        <vs-col
          type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="6"
          class="pl-2"
        >
          <vs-button
            type="border"
            color="primary"
            @click="close"
            class="w-full"
            >{{ $t('cancel') }}</vs-button
          >
        </vs-col>
      </vs-row>
    </div>
  </main-sidebar>
</template>

<script>
import MainSidebar from '@/views/components/MainSidebar.vue'
import vSelect from 'vue-select'
import entry from '@/http/requests/entry'

export default {
  components: {
    MainSidebar,
    vSelect
  },
  props: {
    container: {
       type: Object,
       default: () => {}
    },
    containerTypes: {
      type: Array,
      default: () => []
    },
    entryId: {
      type: String,
      required:true
    }
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },
    isLoading() {
      return this.loading.submit || this.loading.containerTypes
    },
    disabledStore() {
      return (
        this.containerTypes === null || this.errors.any()
      )
    },
    disabledUpdate() {
      return (
        this.containerTypes === null || this.errors.any()
      )
    },
    isEditing() {
      return this.container !== null
    }
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        this.init()
      }
    },
    isLoading(val) {
      if (val) {
        this.openLoading()
      } else {
        this.closeLoading()
      }
    }
  },
  data: () => ({
    name: 'entry-container',
    params:{
        type:'',
        label:'',
        quantity:'',
        location_name:'',
        comment:''
    },
    loading: {
      submit: false
    }
  }),
  methods: {
    init() {
        this.clear()
        this.$validator.reset()
        //set variables
        this.params.type = this.container.type
        this.params.label = this.container.label
        this.params.quantity = this.container.quantity
        this.params.location_name = this.container.location_name
        this.params.comment = this.container.comment
    },
    clear() {
      this.params.type = null
    },
    submitForm() {
        let data = new FormData()
        data.append('container_id', this.container.id)
        data.append('type', this.params.type)
        data.append('entry_id', this.entryId)
        this.updateContainer(data)
    },
    updateContainer(data) {
      this.loading.submit = true
      entry.updateContainer(data).then(res => {
          this.close()
           this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: res.data.message
          })
          this.$emit('containerUpdated')
          this.loading.submit = false
      }).catch( err => {
          this.close()
          console.log(err)
          this.loading.submit = false
      })
    },
    close() {
      this.clear()
      this.$store.dispatch('toggleSidebar', '')
    },
    openLoading() {
      this.$vs.loading({
        container: `#loading-${this.name}-sidebar`,
        scale: 0.6
      })
    },
    closeLoading() {
      this.$vs.loading.close(`#loading-${this.name}-sidebar > .con-vs-loading`)
    }
  }
}
</script>

<style>
.vs__dropdown-menu {
  max-height: 100px;
}

</style>
